import {Fragment} from "react";
import {useTranslation} from "react-i18next";
import {useSelector} from "react-redux";

import {PanelJsonDebug} from "../../component/PanelJsonDebug";
import {useCheckPermissionAdmin} from "../../hooks/permissionHooks";
import {selectExternalValueOrders} from "../../redux/valueOrdersSelectors";
import {selectRevaOrder, selectValueOrders} from "../../redux/valueOrdersSlice";
import {PanelAuflagen} from "./PanelAuflagen";
import {PanelBank} from "./PanelBank";
import {PanelCorrection} from "./PanelCorrection";
import {PanelObject} from "./PanelObject";
import {PanelOrder} from "./PanelOrder";
import {PanelRevaOrder} from "./PanelRevaOrder";
import {PanelStatus} from "./PanelStatus";

function ValueOrdersDebug() {
    const {t} = useTranslation();
    const valueOrders = useSelector(selectValueOrders);
    const isAdmin = useCheckPermissionAdmin();

    if (!isAdmin) return null;

    if (!valueOrders?.length) return null;

    const layoutCols = Math.max(12 / valueOrders.length, 6);
    const layoutColsXxl = Math.max(12 / valueOrders.length, 3);
    const divClass = `col-span-${layoutCols} xxl:col-span-${layoutColsXxl} mt-4`;

    return (
        <>
            <div className="col-span-12">
                <hr className="PanelSeparator" />
            </div>
            {valueOrders.map((order, index) => (
                <div key={`orderDebug-${index}`} className={divClass}>
                    <PanelJsonDebug
                        jsonData={order.orderDetails}
                        title={`Value-Order #${index + 1} Debug: ${t(`order.orderType.${order.orderType}`)} (Admins-Only)`}
                    />
                </div>
            ))}
        </>
    );
}

export default function OrderOverview() {
    const revaOrder = useSelector(selectRevaOrder);
    const externalOrders = useSelector(selectExternalValueOrders);

    return (
        <div className="grow shrink-0 grid grid-cols-12 gap-4">
            <div key="reva-order" className="col-span-12 xl:col-span-6 xxl:col-span-3">
                <PanelRevaOrder />
            </div>
            {revaOrder && (
                <>
                    <div key="reva-bank" className="col-span-12 xl:col-span-6 xxl:col-span-3">
                        <PanelBank orderData={revaOrder} />
                    </div>
                    <div key="reva-obj" className="col-span-12 xl:col-span-6 xxl:col-span-3">
                        <PanelObject orderData={revaOrder} />
                    </div>
                </>
            )}
            <div key="reva-correction" className="col-span-12 xl:col-span-6 xxl:col-span-3">
                <PanelCorrection />
            </div>
            <div key="auflagen" className="col-span-12 mt-4">
                <PanelAuflagen />
            </div>

            {externalOrders.map((order, index) => (
                <Fragment key={order.valueOrderGuid}>
                    <div className="col-span-12">
                        <hr className="PanelSeparator" />
                    </div>
                    <div className="col-span-12 xl:col-span-6 xxl:col-span-3 mt-4">
                        <PanelOrder orderData={order} index={index} />
                    </div>
                    <div className="col-span-12 xl:col-span-6 xxl:col-span-3 mt-4">
                        <PanelBank orderData={order} />
                    </div>
                    <div className="col-span-12 xl:col-span-6 xxl:col-span-3 mt-4">
                        <PanelObject orderData={order} />
                    </div>
                    <div className="col-span-12 xl:col-span-6 xxl:col-span-3 mt-4">
                        <PanelStatus orderData={order} />
                    </div>
                </Fragment>
            ))}

            <ValueOrdersDebug />
        </div>
    );
}
